import { ContextMenuItem } from '@cad-arc';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';

export function EditUnitItem({ unitId }: { unitId: number }): React.ReactElement {
    const drawerControls = useDrawerControls();
    return (
        <ContextMenuItem
            onSelect={() => {
                drawerControls.open({
                    type: 'log-on-edit-unit',
                    props: { unitId },
                });
            }}
        >
            Edit Unit
        </ContextMenuItem>
    );
}

export function EditTemporaryUnitItem({ unitId }: { unitId: number }): React.ReactElement {
    const drawerControls = useDrawerControls();
    return (
        <ContextMenuItem
            onSelect={() => {
                drawerControls.open({
                    type: 'edit-temporary-unit',
                    props: { unitId },
                });
            }}
        >
            Edit Temporary Unit
        </ContextMenuItem>
    );
}
